import React, { Component } from 'react';
import Modal from 'react-modal'
import './../../css/LoginSSO.css';
import eye from './../../images/eye - hide.svg';
import openeye from './../../images/view.svg';



Modal.setAppElement('body');
export default class ChangePasswordByUser extends Component {
    constructor() {
        super();
        this.state = {
            showModal: false,
            newpassword: '',
            repeatNewPassword: '',
            password: '',
            typeLeft: 'password',
            typeRight: 'password',
            eyeIconLeft: openeye,
            eyeIconRight: openeye,
            passwordMatches: true,
            borderColor: '',
            isPasswordAlreadyUsed: 0,
            passwordIsNotStrongEnough: false,
            passwordIsNotStrongEnoughMessage: null
        };
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSendPassword = this.handleSendPassword.bind(this);
        this.showHideLeft = this.showHideLeft.bind(this);
        this.showHideRight = this.showHideRight.bind(this);
    }
    showHide(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            type: this.state.type === 'input' ? 'password' : 'input',
            eyeIconUrl: this.state.eyeIconUrl === openeye ? eye : openeye
        })
    }
    handleChange(event) {
        const { value, name } = event.target;
        this.setState({ [name]: value });
    }


    handleOpenModal() {
        this.setState({ showModal: true });
    }

    handleCloseModal() {
        this.setState({
            showModal: false,
            newpassword: '',
            repeatNewPassword: '',
            passwordIsNotStrongEnough: false,
            passwordIsNotStrongEnoughMessage: null,
            passwordMatches: true
        });
        this.props.setNewUserChangePassword();
    }

    showHideLeft(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            typeLeft: this.state.typeLeft === 'input' ? 'password' : 'input',
            eyeIconLeft: this.state.eyeIconLeft === openeye ? eye : openeye
        })
    }
    showHideRight(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            typeRight: this.state.typeRight === 'input' ? 'password' : 'input',
            eyeIconRight: this.state.eyeIconRight === openeye ? eye : openeye
        })
    }

    handleSendPassword(event) {
        event.preventDefault();
        var md5 = require('md5'),
            self = this,
            userData = this.props.userData,
            oldPassword = this.props.oldPassword;
        const { newpassword, repeatNewPassword } = this.state;
        const passwordMatches = newpassword === repeatNewPassword;
        if (passwordMatches) {
            this.setState({
                passwordMatches: true
            })
            fetch('changePassword?newPassword=' + this.state.newpassword + '&username=' + userData['username'] + '&oldPassword=' + oldPassword, {
                method: 'POST',
            }).then(response => response.json())
                .then((response) => {
                    if (response.message === null) {
                        self.handleCloseModal();
                        self.setState({
                            passwordIsNotStrongEnough: false,
                            passwordIsNotStrongEnoughMessage: null
                        })
                    } else {
                        self.setState({
                            passwordIsNotStrongEnough: true,
                            passwordIsNotStrongEnoughMessage: response.message
                        })
                    }
                })
        } else {
            this.setState({
                passwordMatches: false,
                passwordIsNotStrongEnough: false,
                passwordIsNotStrongEnoughMessage: null
            })
        }
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.newUserChangePassword !== this.props.newUserChangePassword) {
            this.setState({ showModal: nextProps.newUserChangePassword });
        }
    }

    render() {
        const { password } = this.state;
        let {
            userData,
            composingLabel
        } = this.props;


        return (
            < div >
                <Modal className="changePasswordModal changePasswordByUserModal" overlayClassName="Overlay changePasswordByUserModalOverlay" isOpen={this.state.showModal} onRequestClose={this.handleCloseModal}>
                    <p className='forgoten-text'>{composingLabel('sportOauthLabel.changePassword', 'Change password')}</p>
                    {userData != null && userData != undefined && userData.role !== undefined && userData.role !== null && <p>{composingLabel('sportOauthLabel.followGuidelinesForNewPassword', 'Follow these guidelines to create strong password', false)}</p>}
                    {userData != null && userData != undefined && userData.role !== undefined && userData.role !== null &&
                        <ul>
                            <li>{composingLabel('sportOauthLabel.changePassword.be', 'be')} <b>{composingLabel('sportOauthLabel.changePassword.minimum', 'minimum')} {userData.role['passwordMinLength']}</b> {composingLabel('sportOauthLabel.changePassword.charactersLong', 'characters long')}</li>
                            < li > {composingLabel('sportOauthLabel.changePassword.be', 'be')} <b>{composingLabel('sportOauthLabel.changePassword.maximum', 'maximum')} {userData.role['passwordMaxLength']}</b> {composingLabel('sportOauthLabel.changePassword.charactersLong', 'characters long')}</li>
                            < li > {userData.role['hasNumerics'] === false ? composingLabel('sportOauthLabel.changePassword.can', 'can') : composingLabel('sportOauthLabel.changePassword.must', 'must')} {composingLabel('sportOauthLabel.changePassword.containNumerics', 'contain numerics')} </li>
                            <li>{userData.role['notEqualUsername'] === true ? composingLabel('sportOauthLabel.changePassword.not', 'not') : composingLabel('sportOauthLabel.changePassword.can', 'can')} {composingLabel('sportOauthLabel.changePassword.beSameAsUserName', 'be the same as username')} </li>
                            <li>{userData.role['hasUpLowCase'] === true ? composingLabel('sportOauthLabel.changePassword.must', 'must') : composingLabel('sportOauthLabel.changePassword.can', 'can')} {composingLabel('sportOauthLabel.changePassword.containUpperAndLowerCaseChars', 'contain upper and lower case characters')} </li>
                        </ul>}
                    <div className='inputFieldForgotten inputFieldForgottenChangeByUser'>
                        <fieldset className='createNewPassFieldset'>
                            <label className='newPasswordText newPasswordTextByUser'>{composingLabel('sportOauthLabel.changePassword.createNewPAss', 'Create new password', false)}</label>
                            <span className='changePassByUserInputWrapper'>
                                <input name="newpassword" className='newPassword newPasswordByUser' type={this.state.typeLeft} value={this.state.newpassword} onChange={this.handleChange} />
                                <img className="eyeIcon" src={this.state.eyeIconLeft} alt="" onClick={this.showHideLeft}></img>
                            </span>
                        </fieldset>

                        {/* {this.state.type === 'input' ? '' : ''} */}
                        <fieldset className='repeatNewPassFieldset'>
                            <label className='repeatNewPasswordText repeatNewPasswordTextByUser'>{composingLabel('sportOauthLabel.changePassword.repeatNewPass', 'Repeat new password', false)}</label>
                            <span className='changePassByUserInputWrapper'>
                                <input style={{ borderColor: this.props.color }} name="repeatNewPassword" className='repeatNewPassword repeatNewPasswordByUser' type={this.state.typeRight} value={this.state.repeatNewPassword} onChange={this.handleChange} />
                                <img className="eyeIcon" src={this.state.eyeIconRight} alt="" onClick={this.showHideRight}></img>
                            </span>
                        </fieldset>

                        {/* {this.state.type === 'input' ? '' : ''} */}
                        {this.state.passwordMatches === false && <span className='matchPassword'>{composingLabel('sportOauthLabel.changePassword.passDontMatch', 'Passwords don\'t match')}</span>}
                        {this.state.passwordIsNotStrongEnough === true && <span className='matchPassword'> {this.state.passwordIsNotStrongEnoughMessage} </span>}
                    </div>
                    <div className='buttonContainer'>
                        <button id="close" className='forgoten-button-cancel' onClick={this.handleCloseModal}>{composingLabel('sportOauthLabel.cancel', 'Cancel')}</button>
                        <button className='forgoten-button' onClick={this.handleSendPassword}>{composingLabel('sportOauthLabel.changePassword.savePass', 'Save password')}</button>

                    </div>
                </Modal>
            </div >
        );
    }

}


// WEBPACK FOOTER //
// ./src/main/resources/js/components/forgottenPassword/ChangePasswordByUser.js